const CACHE_KEYS = [
  "home",
  "about",
  "categories",
  "services",
  "portfolio",
  "map",
  "contacts",
  "articles",
  "reviews",
  "faq",
  "feedback",
  "docs",
];

const cache = {
  home: null,
  about: null,
  categories: null,
  services: null,
  portfolio: null,
  map: null,
  contacts: null,
  articles: null,
  reviews: null,
  faq: null,
  feedback: null,
  docs: null,
  users: [],
  requests: [],
};

let currentUser = null;
let readyResolve;
const ready = new Promise((resolve) => {
  readyResolve = resolve;
});

function emitReady() {
  document.dispatchEvent(new CustomEvent("nm:api-ready", { detail: cache }));
}

function revealPage() {
  document.documentElement.classList.add("nm-ready");
}

window.setTimeout(revealPage, 4000);

async function request(path, options = {}) {
  const headers = { ...(options.headers || {}) };
  if (options.body && !(options.body instanceof FormData) && !headers["Content-Type"]) {
    headers["Content-Type"] = "application/json";
  }

  let body;
  if (options.body instanceof FormData || typeof options.body === "string") {
    body = options.body;
  } else if (options.body != null) {
    body = JSON.stringify(options.body);
  }

  const response = await fetch(path, {
    credentials: "same-origin",
    ...options,
    headers,
    body,
  });

  let payload = null;
  try {
    payload = await response.json();
  } catch (error) {
    payload = null;
  }

  if (!response.ok) {
    const error = new Error(payload?.error || "Ошибка запроса");
    error.status = response.status;
    error.payload = payload;
    throw error;
  }

  return payload;
}

function applyPublic(payload) {
  CACHE_KEYS.forEach((key) => {
    if (payload[key] != null) cache[key] = payload[key];
  });
}

async function loadPublic() {
  const payload = await request("/api/public");
  applyPublic(payload);
  return cache;
}

async function loadAdminState() {
  const payload = await request("/api/admin/state");
  cache.users = payload.users || [];
  cache.requests = payload.requests || [];
  return payload;
}

async function save(key, value) {
  // Commit cache only after a successful response, so a failed save
  // cannot leave the admin UI believing data is on the server.
  if (key === "articles") {
    const payload = await request("/api/admin/articles", { method: "PUT", body: value });
    cache.articles = Array.isArray(payload?.articles)
      ? { articles: payload.articles }
      : value;
    return payload;
  }
  if (key === "users") {
    const payload = await request("/api/admin/users", { method: "PUT", body: value });
    cache.users = payload.users || value;
    return payload;
  }
  const payload = await request(`/api/admin/${key}`, { method: "PUT", body: value });
  cache[key] = payload != null ? payload : value;
  return payload;
}

async function login(loginName, password) {
  const payload = await request("/api/auth/login", {
    method: "POST",
    body: { login: loginName, password },
  });
  currentUser = payload.user;
  try {
    await loadAdminState();
  } catch (error) {
    cache.users = currentUser ? [currentUser] : [];
    cache.requests = [];
  }
  return currentUser;
}

async function logout() {
  try {
    await request("/api/auth/logout", { method: "POST", body: {} });
  } catch (error) {
    // ignore
  }
  currentUser = null;
  cache.users = [];
  cache.requests = [];
}

async function me() {
  try {
    const payload = await request("/api/auth/me");
    currentUser = payload.user || null;
    if (currentUser) await loadAdminState();
    return currentUser;
  } catch (error) {
    currentUser = null;
    return null;
  }
}

async function updateProfile(body) {
  const payload = await request("/api/auth/profile", { method: "PATCH", body });
  currentUser = payload.user;
  return currentUser;
}

async function addRequest(payload) {
  const created = await request("/api/requests", { method: "POST", body: payload });
  cache.requests = [created, ...(cache.requests || [])];
  return created;
}

async function deleteRequest(id) {
  const payload = await request(`/api/admin/requests/${encodeURIComponent(id)}`, { method: "DELETE" });
  cache.requests = payload.requests || [];
  return cache.requests;
}

async function uploadFile(file) {
  const body = new FormData();
  body.append("file", file);
  return request("/api/admin/upload", { method: "POST", body });
}

window.NMApi = {
  cache,
  ready,
  request,
  loadPublic,
  loadAdminState,
  save,
  login,
  logout,
  me,
  updateProfile,
  addRequest,
  deleteRequest,
  uploadFile,
  get user() {
    return currentUser;
  },
  revealPage,
};

loadPublic()
  .catch(() => null)
  .finally(() => {
    readyResolve(cache);
    emitReady();
    if (!document.querySelector("[data-admin-root]")) {
      revealPage();
    }
  });
